(() => {
  const timers = new Set();

  const UNIT_CONFIG = [
    ['months', 30 * 24 * 60 * 60 * 1000],
    ['weeks', 7 * 24 * 60 * 60 * 1000],
    ['days', 24 * 60 * 60 * 1000],
    ['hours', 60 * 60 * 1000],
    ['minutes', 60 * 1000],
    ['seconds', 1000],
  ];

  const readBoolean = (value) => value === true || value === 'true';

  const pluralise = (value, label) => {
    if (value === 1) return label.replace(/s$/, '');
    return label;
  };

  const padIfTimeUnit = (value, unit) => {
    if (['hours', 'minutes', 'seconds'].includes(unit)) {
      return String(value).padStart(2, '0');
    }

    return String(value);
  };

  const buildVisibleUnits = (timer) => {
    const units = {
      months: readBoolean(timer.dataset.showMonths),
      weeks: readBoolean(timer.dataset.showWeeks),
      days: readBoolean(timer.dataset.showDays),
      hours: readBoolean(timer.dataset.showHours),
      minutes: readBoolean(timer.dataset.showMinutes),
      seconds: readBoolean(timer.dataset.showSeconds),
    };

    const hasAtLeastOneUnit = Object.values(units).some(Boolean);

    if (!hasAtLeastOneUnit) {
      units.days = true;
      units.hours = true;
      units.minutes = true;
      units.seconds = true;
    }

    return units;
  };

  const renderTimer = (timer) => {
    const target = Number(timer.dataset.target) * 1000;

    if (!target || Number.isNaN(target)) return;

    const root = timer.closest('[data-bh-countdown-root]');
    const container = root?.closest('[data-bh-countdown-container]') || root;
    const hideExpired = readBoolean(timer.dataset.hideExpired);
    const showLabels = readBoolean(timer.dataset.showLabels);
    const expiredText = timer.dataset.expiredText || '';
    let remaining = target - Date.now();

    if (remaining <= 0) {
      if (hideExpired && container) {
        container.hidden = true;
        return;
      }

      if (container) container.hidden = false;
      if (root) root.hidden = false;
      timer.innerHTML = expiredText;
      return;
    }

    if (container) container.hidden = false;
    if (root) root.hidden = false;

    const visibleUnits = buildVisibleUnits(timer);
    const parts = [];

    UNIT_CONFIG.forEach(([unit, duration]) => {
      if (!visibleUnits[unit]) return;

      const value = Math.floor(remaining / duration);
      remaining -= value * duration;

      parts.push({ unit, value });
    });

    timer.innerHTML = parts
      .map(({ unit, value }) => {
        const number = padIfTimeUnit(value, unit);

        if (!showLabels) {
          return `<span class="bh-countdown__item"><span class="bh-countdown__number">${number}</span></span>`;
        }

        return `
          <span class="bh-countdown__item">
            <span class="bh-countdown__number">${number}</span>
            <span class="bh-countdown__label">${pluralise(value, unit)}</span>
          </span>
        `;
      })
      .join('');
  };

  const initialiseCountdowns = (root = document) => {
    const countdowns = root.matches?.('[data-bh-countdown-timer]')
      ? [root]
      : root.querySelectorAll?.('[data-bh-countdown-timer]') ?? [];

    countdowns.forEach((timer) => {
      timers.add(timer);
      renderTimer(timer);
    });
  };

  initialiseCountdowns();
  setInterval(() => {
    timers.forEach((timer) => {
      if (!timer.isConnected) {
        timers.delete(timer);
        return;
      }

      renderTimer(timer);
    });
  }, 1000);

  const countdownObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) initialiseCountdowns(node);
      });
    });
  });

  countdownObserver.observe(document.documentElement, { childList: true, subtree: true });

  const initialiseFromShopifyEvent = (event) => {
    initialiseCountdowns(event.target instanceof Element ? event.target : document);
  };

  document.addEventListener('shopify:section:load', initialiseFromShopifyEvent);
  document.addEventListener('shopify:block:select', initialiseFromShopifyEvent);
})();